module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "image-filter__container"
  }, [_c('el-header', {
    staticClass: "image-filter__header"
  }, [_c('image-toolbar')], 1), _vm._v(" "), _c('el-container', {
    staticClass: "image-filter__body"
  }, [_c('el-aside', {
    style: ({
      width: _vm.isNavigatorOpen ? _vm.navigatorWidth : '0px'
    })
  }, [_c('image-navigator')], 1), _vm._v(" "), _c('image-editor')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a4b2bfd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/image-filter/image-filter.vue
// module id = 280
// module chunks = 0